import React, { useContext, useState } from 'react';
import './anthem.scss';
import ReactMarkdown from 'react-markdown';

// CONTEXT
import AboutusContext from '../../../../../contexts/pages/aboutus/aboutusContext';
import Slider from '../../Slider';


const Anthem = () => {

    const aboutusContext = useContext(AboutusContext);
    const { anthem, history } = aboutusContext;
    const [isVideoPlaying, setIsVideoPlaying] = useState(false);

    return (
        <div className="aboutus-subpage anthem">
            {history ? (<Slider bannerData={history.banner} />) : null}
            <div className="anthem-inner">
                <h2 className="anthem-title">{anthem ? anthem.titulo : "Himno Babeque"}</h2>
                <div className="anthem-video">
                    <div className="anthem-video-frame">
                        {isVideoPlaying ? (
                            <iframe
                                src="https://www.youtube.com/embed/v4Mlz84u1Go?autoplay=1&rel=0"
                                title="Video del Himno Babeque"
                                referrerPolicy="strict-origin-when-cross-origin"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                allowFullScreen
                            />
                        ) : (
                            <button
                                className="anthem-video-poster"
                                type="button"
                                onClick={() => setIsVideoPlaying(true)}
                                aria-label="Reproducir el video del Himno Babeque"
                            >
                                <img
                                    src="https://i.ytimg.com/vi/v4Mlz84u1Go/maxresdefault.jpg"
                                    alt=""
                                    loading="lazy"
                                />
                                <span className="anthem-play-icon" aria-hidden="true" />
                            </button>
                        )}
                    </div>
                    <div className="anthem-video-footer">
                        <span>Himno Babeque</span>
                        <a href="https://youtu.be/v4Mlz84u1Go" target="_blank" rel="noopener noreferrer">
                            Ver en YouTube <span aria-hidden="true">↗</span>
                        </a>
                    </div>
                </div>
                <div className="anthem-text">
                    {anthem
                       &&
                        // <DialogContentText>
                            <ReactMarkdown>
                                {anthem.descripcion}
                            </ReactMarkdown>
                        // </DialogContentText>
                    }
                </div>
            </div>
        </div>
    )
}

export default Anthem;
